import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
const steps = [{
  num: '01',
  title: 'Enter the Drawing',
  desc: 'Players see the prize pool and tap to enter — free.',
  img: 'https://cdn.magicpatterns.com/uploads/55s2c7vExK878JG4gJYhWD/iPhone-14-PRO-MAX-free2playsports.skycity.com.png',
  alt: 'Sky City Casino drawing entry screen showing a $300 prize pool and an Enter Now button'
}, {
  num: '02',
  title: 'Spin to Multiply',
  desc: 'A quick wheel spin boosts their entries — up to 10x.',
  img: 'https://cdn.magicpatterns.com/uploads/oWnGeEq7eJGVQ9wPBtFmaU/iPhone-14-PRO-MAX-free2playsports.skycity.com_(3).png',
  alt: 'Multiplier round screen with a prize wheel awarding a 2x entry bonus'
}, {
  num: '03',
  title: 'Verify & Win',
  desc: 'They confirm details to lock in entries and become eligible.',
  img: 'https://cdn.magicpatterns.com/uploads/35aArK9cJgo7i6RD4A3JTN/iPhone-14-PRO-MAX-free2playsports.skycity.com_(4).png',
  alt: 'Verify and complete screen showing 30 total entries and a registration form'
}];
export function SlideWalkthrough() {
  return <div className="w-full min-h-full flex flex-col justify-center p-[clamp(1.5rem,4vw,4rem)]" data-id="element-221">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center mb-[clamp(1.25rem,3vw,2.5rem)]" data-id="element-222">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-surface-hover text-accent text-sm font-bold tracking-wide uppercase mb-4" data-id="element-223">
          See It In Action
        </div>
        <h2 className="text-[clamp(2rem,4vw,3.5rem)] font-bold leading-tight" data-id="element-224">
          A Real Drawing, <span className="text-accent" data-id="element-225">Tap by Tap</span>
        </h2>
      </motion.div>

      <div className="flex overflow-x-auto md:overflow-visible snap-x snap-mandatory hide-scrollbar items-stretch justify-start md:justify-center gap-[clamp(1rem,2vw,2.5rem)] pb-4 md:pb-0 w-[calc(100%+clamp(3rem,8vw,8rem))] -ml-[clamp(1.5rem,4vw,4rem)] px-[clamp(1.5rem,4vw,4rem)] md:w-full md:ml-0 md:px-0" data-id="element-226">
        {steps.map((step, i) => <Fragment key={step.num} data-id="element-227">
            <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + i * 0.2,
          duration: 0.5
        }} className="flex flex-col items-center text-center flex-none w-[85vw] md:flex-1 md:w-auto max-w-[280px] snap-center" data-id="element-228">
              <div className="relative mb-3 md:mb-4" data-id="element-229">
                <img src={step.img} alt={step.alt} className="h-[clamp(16rem,46vh,30rem)] w-auto object-contain drop-shadow-2xl" data-id="element-230" />
                <div className="absolute -top-2 -left-2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-accent text-accent-contrast flex items-center justify-center font-display font-black text-xs md:text-sm shadow-[0_0_20px_rgba(59,246,93,0.4)]" data-id="element-231">
                  {step.num}
                </div>
              </div>
              <h3 className="text-base md:text-lg font-bold mb-0.5 md:mb-1" data-id="element-232">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-muted leading-relaxed max-w-[14rem]" data-id="element-233">
                {step.desc}
              </p>
            </motion.div>

            {i < steps.length - 1 && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4 + i * 0.2
        }} className="hidden md:flex items-center self-center text-accent-secondary shrink-0" aria-hidden="true" data-id="element-234">
                <ChevronRight size={28} data-id="element-235" />
              </motion.div>}
          </Fragment>)}
      </div>
    </div>;
}